<form [formGroup]="form">
    <div fxLayout="column" fxLayoutAlign="start">
        <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch">

            <mat-form-field appearance="outline" fxFlex="100%" class="px-2">
                <mat-label>* Título</mat-label>
                <input matInput formControlName="titulo" minlength="1" maxlength="50" cleanWhiteSpace>
            </mat-form-field>

        </div>

        <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
             fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch">

            <mat-form-field appearance="outline" fxFlex="100%" class="px-2">
                <mat-label>Descripción</mat-label>
                <textarea matInput formControlName="descripcion" #descripcion minlength="1" maxlength="100"
                          cleanWhiteSpace rows="4"></textarea>
                <mat-hint align="end">{{descripcion.value.length}} / 100</mat-hint>
            </mat-form-field>

        </div>
    </div>
</form>
